// Trocar (ou informar) o Client Secret do app do Mercado Livre.
// PUT /api/admin/channels/:slug/secrets: so escrita, a API cifra e nunca devolve o valor.
// O campo usa o PasswordField da casa (comeca oculto, botao de mostrar/ocultar com rotulo).
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, apiErrorMessage } from "../../lib/api";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { PasswordField } from "../ui/PasswordField";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from "../ui/dialog";

export function MlSecretDialog({
  slug,
  hasSecret,
  open,
  onOpenChange,
}: {
  slug: string;
  hasSecret: boolean;
  open: boolean;
  onOpenChange: (o: boolean) => void;
}): JSX.Element {
  const qc = useQueryClient();
  const [value, setValue] = useState("");
  const save = useMutation({
    mutationFn: async () => (await api.put(`/api/admin/channels/${slug}/secrets`, { secrets: { client_secret: value.trim() } })).data,
    onSuccess: () => {
      toast.success("Client Secret salvo");
      setValue("");
      void qc.invalidateQueries({ queryKey: ["ml-status", slug] });
      onOpenChange(false);
    },
    onError: (e) => toast.error(apiErrorMessage(e)),
  });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{hasSecret ? "Trocar o Client Secret" : "Informar o Client Secret"}</DialogTitle>
          <DialogDescription>
            É a chave secreta do app "Vitrine Hiit" no painel de desenvolvedor do Mercado Livre. Fica guardada cifrada e
            nunca volta para esta tela.
          </DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (value.trim()) save.mutate();
          }}
          className="stack"
          style={{ gap: "var(--sp-3)" }}
        >
          <div className="field">
            <Label htmlFor="ml-secret">Client Secret</Label>
            <PasswordField
              id="ml-secret"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              autoComplete="new-password"
              spellCheck={false}
              autoFocus
            />
            <p className="field__hint">
              {hasSecret
                ? "Já existe um Client Secret salvo. Trocar não desconecta o canal; vale na próxima renovação do acesso."
                : "Depois de salvar, clique em Conectar ao Mercado Livre."}
            </p>
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button type="button" variant="outline">Cancelar</Button>
            </DialogClose>
            <Button type="submit" disabled={!value.trim() || save.isPending}>Salvar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
